var _path, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMinifyTool(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 13a6.994 6.994 0 01-3.177 5.865l1.105 2.764a1 1 0 01-1.857.742l-1.065-2.663A7 7 0 1121 13zm-7 5a5 5 0 100-10 5 5 0 000 10z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 12,
    width: 6,
    height: 2,
    rx: 0.5,
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinifyTool);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgiIGhlaWdodD0iMjgiIHZpZXdCb3g9IjAgMCAyOCAyOCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMSAxM0MyMSAxNS40NTUzIDE5LjczNTkgMTcuNjE1NCAxNy44MjMgMTguODY0OEwxOC45Mjg1IDIxLjYyODZDMTkuMTMzNiAyMi4xNDE0IDE4Ljg4NDIgMjIuNzIzNCAxOC4zNzE0IDIyLjkyODVDMTcuODU4NiAyMy4xMzM2IDE3LjI3NjYgMjIuODg0MiAxNy4wNzE1IDIyLjM3MTRMMTYuMDA2MyAxOS43MDgzQzE1LjM3MDcgMTkuODk4MSAxNC42OTczIDIwIDE0IDIwQzEwLjEzNCAyMCA3IDE2Ljg2NiA3IDEzQzcgOS4xMzQwMSAxMC4xMzQgNiAxNCA2QzE3Ljg2NiA2IDIxIDkuMTM0MDEgMjEgMTNaTTE0IDE4QzE2Ljc2MTQgMTggMTkgMTUuNzYxNCAxOSAxM0MxOSAxMC4yMzg2IDE2Ljc2MTQgOCAxNCA4QzExLjIzODYgOCA5IDEwLjIzODYgOSAxM0M5IDE1Ljc2MTQgMTEuMjM4NiAxOCAxNCAxOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cmVjdCB4PSIxMSIgeT0iMTIiIHdpZHRoPSI2IiBoZWlnaHQ9IjIiIHJ4PSIwLjUiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };